import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';

Vue.use(BootstrapVue);



// WEBPACK FOOTER //
// ./src/plugins/bootstrap.js